"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/extent/Relationship
 */

/**
 * Relationship to an extent.
 * @enum {number}
 */
var _default = {
  UNKNOWN: 0,
  INTERSECTING: 1,
  ABOVE: 2,
  RIGHT: 4,
  BELOW: 8,
  LEFT: 16
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiQSxPQUFPLEVBQUUsQ0FESTtFQUViQyxZQUFZLEVBQUUsQ0FGRDtFQUdiQyxLQUFLLEVBQUUsQ0FITTtFQUliQyxLQUFLLEVBQUUsQ0FKTTtFQUtiQyxLQUFLLEVBQUUsQ0FMTTtFQU1iQyxJQUFJLEVBQUU7QUFOTyxDIiwibmFtZXMiOlsiVU5LTk9XTiIsIklOVEVSU0VDVElORyIsIkFCT1ZFIiwiUklHSFQiLCJCRUxPVyIsIkxFRlQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2V4dGVudC9SZWxhdGlvbnNoaXAuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=